module.exports = __webpack_public_path__ + "static/media/fun4.c629a6a5.png";